const {__, _x, _n, _nx} = wp.i18n;

//Bootstrap component list: Alert, BaseComponent, Button, Carousel, Collapse, Dropdown, Modal, Offcanvas, Popover, ScrollSpy, Tab, Tooltip, Toast
import {Collapse} from 'bootstrap';
import SimpleLightbox from "simplelightbox";

require('./utilities/class_enlarge.js');
require('./utilities/class_count.js');
require('./utilities/pdw_mobile_menu.js');
require('./utilities/pdw_modal_search.js');
require('./utilities/pdw_carousel.js');
require('./utilities/pdw_slider.js');
require('./utilities/pdw_hide_link.js');
//require('./utilities/pdw_woocommerce.js');

//Lightbox
let lightbox = new SimpleLightbox('.pdw-lightbox a', { /* options */});

//Drilldown menu
window.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll('ul.mobile-drilldown-menu li.menu-item-has-children > a').forEach(element => {
        //Create previous button
        let previous = document.createElement('span');
        element.nextElementSibling.prepend(previous);
        previous.classList.add("pdw-submenu-close");
        previous.innerHTML = element.innerHTML;
        previous.addEventListener("click", (event) => {
            event.preventDefault();
            event.target.parentElement.parentElement.classList.remove("open");
        });
        //Create open button
        let span = document.createElement('span');
        element.appendChild(span);
        span.classList.add("pdw-submenu-open");
        span.addEventListener("click", (event) => {
            event.preventDefault();
            event.target.parentElement.parentElement.classList.add("open");
            document.getElementById('pdw-mobile-menu').scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
        });
    });
});




import Splide from '@splidejs/splide';

//slider home top
if(document.querySelector('.home_top')) {
    document.addEventListener( 'DOMContentLoaded', function() {

        var home_top_slider = new Splide('.home_top--slider', {
            type: 'fade',
            autoplay: true,
            interval:'5000',
            speed: '1000',
            rewind:true,
            arrows : false,
            pauseOnHover: false,
            easing : 'cubic-bezier(0.25, 1, 0.5, 1)',
            classes: {
                pagination: 'slider--dots',
                page: 'dot'
            }
        });

        home_top_slider.mount();
    });
}


//slider home products
if(document.querySelector('.home_products')) {
    document.addEventListener( 'DOMContentLoaded', function() {

        var home_products_slider = new Splide('.home_products--slider', {
            type: 'loop',
            speed: '800',
            autoplay: true,
            interval: '5000',
            perPage: 3,
            perMove: 3,
            pauseOnHover: false,
            gap:'3rem',
            arrows : false,
            easing : 'cubic-bezier(0.25, 1, 0.5, 1)',
            pagination:false,
            breakpoints: {
                767: {
                    perPage: 1,
                    perMove: 1
                },
                991: {
                    perPage: 2,
                    perMove: 2
                }
            }
        });

        home_products_slider.mount();

        var btn_prev = document.querySelector('.home_products--slider .nav--prev');
        var btn_next = document.querySelector('.home_products--slider .nav--next');

        btn_prev.addEventListener("click", function () {
            home_products_slider.go('<');
        });
        btn_next.addEventListener("click", function () {
            home_products_slider.go('>');
        });
    });
}


//slider home partners
if(document.querySelector('.home_partners')) {
    document.addEventListener( 'DOMContentLoaded', function() {

        var home_partners_slider = new Splide('.home_partners--slider', {
            type: 'loop',
            autoplay: true,
            interval: '2500',
            speed: '1000',
            perPage: 5,
            perMove: 3,
            pauseOnHover: false,
            arrows: false,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
            pagination: false,
            breakpoints: {
                767: {
                    perPage: 2,
                    perMove: 2
                },
                991: {
                    perPage: 4,
                    perMove: 2
                }
            }
        });

        home_partners_slider.mount();
    });
}


//slider products
if(document.querySelector('.product_gallery')) {
    document.addEventListener( 'DOMContentLoaded', function() {

        var product_gallery_slider = new Splide('.product_gallery--slider', {
            type: 'fade',
            speed: '1000',
            pauseOnHover: false,
            easing : 'cubic-bezier(0.25, 1, 0.5, 1)',
            pagination : false,
            arrows     : false,
            cover      : true,
        });

        var thumbnails = document.getElementsByClassName( 'thumb_wrap' );
        var current;

        for ( var i = 0; i < thumbnails.length; i++ ) {
            initThumbnail( thumbnails[ i ], i );
        }

        function initThumbnail( thumbnail, index ) {
            thumbnail.addEventListener( 'click', function () {
                product_gallery_slider.go( index );
            } );
        }

        product_gallery_slider.on( 'mounted move', function () {
            var thumbnail = thumbnails[ product_gallery_slider.index ];

            if ( thumbnail ) {
                if ( current ) {
                    current.classList.remove( 'is-active' );
                }

                thumbnail.classList.add( 'is-active' );
                current = thumbnail;
            }
        } );

        /*product_gallery_slider.sync( product_gallery_thumbs );*/
        product_gallery_slider.mount();
        /*product_gallery_thumbs.mount();*/
    });
}